// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yRmnZ.ui.label{background-color:var(--artifact-type-label-background-color);color:var(--artifact-type-label-color);cursor:default}:root[data-darkreader-scheme=dark] .yRmnZ.ui.label{color:var(--anchore-color-gray-750)}.yRmnZ.ui.label.cAf1r{padding:.4rem .5rem}.yRmnZ.ui.label.jfEhs{--artifact-type-label-background-color:#a657a64d;--artifact-type-label-color:#733074}.yRmnZ.ui.label.G4wmi{--artifact-type-label-background-color:#7c60b84d;--artifact-type-label-color:#4b2897}.yRmnZ.ui.label.CVXdp{--artifact-type-label-background-color:#ab75534d;--artifact-type-label-color:#774a2d}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `yRmnZ`,
	"compact": `cAf1r`,
	"image": `jfEhs`,
	"sbom": `G4wmi`,
	"source": `CVXdp`
};
module.exports = ___CSS_LOADER_EXPORT___;
